module.exports = __webpack_public_path__ + "img/default_profile_pic.e6a8bcc7.png";